import { createDarkTheme } from "../default/Dark";

const res = createDarkTheme({ colorAccent: "#EB2553" });
res.default.logoSize = { width: 15.7, height: 2.4 };
export default res;
